import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";

import ContextProviders from "@/ContextProviders";
import AppRouter from "@/router";

import queryClient from "@/utils/global/queryClient";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ContextProviders>
        <AppRouter />
      </ContextProviders>
    </QueryClientProvider>
  </StrictMode>
);
